import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';
import { RotateCcw } from 'lucide-react';
const before = ['Mensaje', 'Persona responde', 'Copia información', 'Actualiza CRM', 'Pregunta disponibilidad', 'Busca calendario', 'Confirma', 'Recuerda', 'Hace seguimiento'];
const withOrigen = ['Mensaje', 'IA', 'Calificación', 'CRM', 'Agenda', 'Seguimiento'];
type Vertical = 'servicios' | 'inmobiliaria' | 'odonto' | 'educacion' | 'ecommerce' | 'estetica';
interface VerticalContent {
  label: string;
  clientMsg: string;
  aiTyping: string;
  aiReply: string;
  clientReply: string;
  aiConfirm: string;
  panel1: {
    k: string;
    v: string;
  }[];
  qualified: string;
  panel2Title: string;
  panel2Chips: string[];
  crmText: string;
  actionText: string;
  followupText: string;
}
const content: Record<Vertical, VerticalContent> = {
  servicios: {
    label: 'Servicios',
    clientMsg: 'Necesito una cotización para mi empresa.',
    aiTyping: 'Analizando intención...',
    aiReply: 'Claro, ¿qué servicio necesitas y para cuántas personas aproximadamente?',
    clientReply: 'Consultoría para unas 30 personas.',
    aiConfirm: 'Perfecto. Voy a registrar la solicitud.',
    panel1: [{
      k: 'Servicio',
      v: 'Consultoría'
    }, {
      k: 'Tamaño',
      v: '20-50 personas'
    }],
    qualified: 'Intención: Alta',
    panel2Title: 'DISPONIBILIDAD ENCONTRADA',
    panel2Chips: ['Mañana · 10:00', 'Mañana · 15:00'],
    crmText: 'Lead actualizado',
    actionText: 'Cotización enviada',
    followupText: 'Seguimiento comercial activado'
  },
  inmobiliaria: {
    label: 'Inmobiliaria',
    clientMsg: 'Hola, vi el apartamento de 3 habitaciones. Quiero visitarlo.',
    aiTyping: 'Analizando intención...',
    aiReply: 'Claro, puedo darte el precio, las características o agendar una visita.',
    clientReply: 'Prefiero agendar la visita este sábado.',
    aiConfirm: 'Listo. Voy a confirmar la disponibilidad.',
    panel1: [{
      k: 'Propiedad',
      v: 'Apto. 3 habitaciones'
    }, {
      k: 'Estado',
      v: 'Calificado'
    }],
    qualified: 'Intención: Alta',
    panel2Title: 'DISPONIBILIDAD ENCONTRADA',
    panel2Chips: ['Mañana · 11:00', 'Sábado · 10:00'],
    crmText: 'Nuevo lead registrado',
    actionText: 'Visita agendada',
    followupText: 'Seguimiento automático activado'
  },
  odonto: {
    label: 'Odontología',
    clientMsg: 'Hola, quiero información sobre diseño de sonrisa.',
    aiTyping: 'Analizando intención...',
    aiReply: 'Claro, puedo ayudarte con información, disponibilidad y agendamiento.',
    clientReply: 'Prefiero en la mañana, si es posible.',
    aiConfirm: 'Perfecto. Voy a revisar los horarios disponibles.',
    panel1: [{
      k: 'Servicio',
      v: 'Diseño de sonrisa'
    }, {
      k: 'Fuente',
      v: 'WhatsApp'
    }],
    qualified: 'Interés: Alto',
    panel2Title: 'DISPONIBILIDAD ENCONTRADA',
    panel2Chips: ['Mañana · 10:00', 'Mañana · 15:00'],
    crmText: 'Nuevo lead registrado',
    actionText: 'Cita agendada',
    followupText: 'Seguimiento automático activado'
  },
  educacion: {
    label: 'Educación',
    clientMsg: 'Quiero información sobre el programa.',
    aiTyping: 'Analizando intención...',
    aiReply: 'Claro, puedo explicarte el programa, requisitos, duración y agendar una llamada.',
    clientReply: 'Sí, me interesa conocer los horarios.',
    aiConfirm: 'Claro. Voy a registrar tu interés.',
    panel1: [{
      k: 'Programa',
      v: 'Maestría en Marketing'
    }, {
      k: 'Fuente',
      v: 'WhatsApp'
    }],
    qualified: 'Interés: Alto',
    panel2Title: 'DISPONIBILIDAD ENCONTRADA',
    panel2Chips: ['Mañana · 9:00', 'Jueves · 16:00'],
    crmText: 'Nuevo lead registrado',
    actionText: 'Llamada agendada',
    followupText: 'Seguimiento automático activado'
  },
  ecommerce: {
    label: 'E-commerce',
    clientMsg: '¿Tienen disponible este producto?',
    aiTyping: 'Consultando inventario...',
    aiReply: 'Sí, puedo ayudarte con disponibilidad, características y el proceso de compra.',
    clientReply: 'Sí, quiero comprarlo.',
    aiConfirm: 'Perfecto. Voy a confirmar tu pedido.',
    panel1: [{
      k: 'Producto',
      v: 'Disponible'
    }, {
      k: 'Fuente',
      v: 'WhatsApp'
    }],
    qualified: 'Intención: Compra directa',
    panel2Title: 'PROCESO DE COMPRA',
    panel2Chips: ['Pedido confirmado', 'Envío programado'],
    crmText: 'Cliente registrado',
    actionText: 'Compra confirmada',
    followupText: 'Seguimiento postventa activado'
  },
  estetica: {
    label: 'Estética',
    clientMsg: 'Quiero información sobre depilación láser.',
    aiTyping: 'Analizando intención...',
    aiReply: 'Claro, puedo darte información sobre el servicio y consultar disponibilidad.',
    clientReply: 'Prefiero en la tarde, si hay cupo.',
    aiConfirm: 'Voy a revisar la disponibilidad para ti.',
    panel1: [{
      k: 'Servicio',
      v: 'Depilación láser'
    }, {
      k: 'Fuente',
      v: 'WhatsApp'
    }],
    qualified: 'Interés: Alto',
    panel2Title: 'DISPONIBILIDAD ENCONTRADA',
    panel2Chips: ['Mañana · 11:00', 'Viernes · 16:00'],
    crmText: 'Nuevo lead registrado',
    actionText: 'Cita agendada',
    followupText: 'Seguimiento automático activado'
  }
};
const verticalOrder: Vertical[] = ['servicios', 'inmobiliaria', 'odonto', 'educacion', 'ecommerce', 'estetica'];

// message -> typing -> reply -> client reply -> ai confirm -> datos extraídos -> calificación -> panel2 -> CRM -> acción -> seguimiento
const STEP_DELAYS = [200, 1000, 1900, 2800, 3600, 4500, 5300, 6200, 7100, 8000, 8900];
export function OriginInAction() {
  const [vertical, setVertical] = useState<Vertical>('servicios');
  const [step, setStep] = useState(0);
  const [playKey, setPlayKey] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(containerRef, {
    once: true,
    amount: 0.4
  });
  const data = content[vertical];
  useEffect(() => {
    if (!isInView) return;
    const prefersReduced = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      setStep(11);
      return;
    }
    const timers = STEP_DELAYS.map((delay, idx) => setTimeout(() => setStep(idx + 1), delay));
    return () => {
      timers.forEach(clearTimeout);
    };
  }, [isInView, playKey]);
  const replay = () => {
    setStep(0);
    setPlayKey(k => k + 1);
  };
  const selectVertical = (key: Vertical) => {
    if (key === vertical) return;
    setVertical(key);
    replay();
  };
  return <section id="como-funciona" className="bg-arena py-[100px] md:py-[150px]" data-id="element-119" data-mp="2i8xtu8xkb64b">
      <div className="max-w-[1000px] mx-auto px-6 md:px-20" data-id="element-120" data-mp="2n8k90nwyawfr">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="text-center max-w-[560px] mx-auto mb-20" data-id="element-121" data-mp="2na4zo2g59v8c">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-122" data-mp="1mz2fixacm39h">
            ORIGEN EN ACCIÓN
          </span>
          <h2 className="font-display text-[32px] md:text-[44px] font-medium text-carbon leading-[1.1]" data-id="element-123" data-mp="1daamsmxgrexi">
            Menos tareas repetitivas. Más procesos funcionando.
          </h2>
        </motion.div>

        {/* Before / After — compact comparison */}
        <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 max-w-[820px] mx-auto mb-24" data-id="element-124" data-mp="13dpkwagqqjxw">
          <div aria-hidden="true" className="hidden md:flex absolute left-1/2 top-0 bottom-0 -translate-x-1/2 items-center justify-center w-6 text-verde" data-id="element-125" data-mp="zcvth743an09">
            →
          </div>
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.35,
          ease: 'easeOut'
        }} className="md:pr-4" data-id="element-126" data-mp="2oph8225ad7j0">
            <span className="block font-body text-[10px] uppercase font-medium text-carbon/35 tracking-[0.15em] mb-4" data-id="element-127" data-mp="1snddnsqd4vcd">
              ANTES
            </span>
            <div className="flex flex-wrap gap-1.5" data-id="element-128" data-mp="1iufq386ikg6w">
              {before.map((item, idx) => <motion.span key={item} initial={{
              opacity: 0,
              y: 6
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              ease: 'easeOut',
              delay: 0.1 + idx * 0.05
            }} className="font-body text-[12px] text-carbon/50 border border-carbon/15 px-3 py-1.5" data-id="element-129" data-mp="1ntik7xkyh203" data-mpi={idx}>
                  {item}
                </motion.span>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.35,
          ease: 'easeOut',
          delay: 0.08
        }} className="md:pl-4" data-id="element-130" data-mp="2u8jiwb1d7yad">
            <span className="block font-body text-[10px] uppercase font-medium text-verde tracking-[0.15em] mb-4" data-id="element-131" data-mp="iovj8d5p6wp9">
              CON ORIGEN
            </span>
            <div className="flex flex-wrap gap-1.5" data-id="element-132" data-mp="skygp5plu75v">
              {withOrigen.map((item, idx) => <motion.span key={item} initial={{
              opacity: 0,
              scale: 0.92
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              ease: 'easeOut',
              delay: 0.35 + idx * 0.08
            }} className="font-body text-[13px] font-medium text-arena bg-verde px-3.5 py-1.5" data-id="element-133" data-mp="16cbwc8ke6kvm" data-mpi={idx}>
                  {item}
                </motion.span>)}
            </div>
          </motion.div>
        </div>

        {/* Demo — see the same pipeline run for a real business */}
        <p className="text-center font-body text-[13px] text-carbon/40 mb-4" data-id="element-134" data-mp="ta2cpebjrisn">
          Así se ve funcionando en un negocio real.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-1.5 mb-10 text-carbon/35" data-id="element-135" data-mp="jb3b2fp78nf5">
          {['MENSAJE', 'IA', 'DATOS', 'CALIFICACIÓN', 'CRM', 'ACCIÓN', 'SEGUIMIENTO'].map((stage, idx) => <span key={stage} className="flex items-center gap-1.5" data-id="element-136" data-mp="1c0a6h5tcwww6" data-mpi={idx}>
                <span className="font-body text-[11px] uppercase tracking-[0.1em] font-medium" data-id="element-137" data-mp="170nuezp9lmoy">
                  {stage}
                </span>
                {idx < 6 && <span className="text-[11px]" data-id="element-138" data-mp="128mjbh3u220i">→</span>}
              </span>)}
        </div>

        <div className="flex items-center justify-center gap-2 mb-4 flex-wrap px-2 -mx-2 overflow-x-auto" data-id="element-139" data-mp="y83s9p9rkzzd">
          {verticalOrder.map(key => <button key={key} onClick={() => selectVertical(key)} className={`font-body text-[13px] font-medium px-4 py-2.5 rounded-[6px] border transition-all duration-200 flex-shrink-0 ${vertical === key ? 'bg-verde text-arena border-verde' : 'bg-transparent text-carbon/60 border-carbon/15 hover:text-carbon hover:border-carbon/30'}`} data-id="element-140" data-mp="1pz05ws3nf8np">
              {content[key].label}
            </button>)}
        </div>
        <p className="text-center font-body text-[12px] text-carbon/40 italic mb-16 max-w-[480px] mx-auto" data-id="element-141" data-mp="3rkmbac4dxbu3">
          Ejemplos de aplicación — ORIGEN se adapta a distintos negocios con
          procesos de atención, calificación y agendamiento.
        </p>

        <div ref={containerRef} className="bg-carbon rounded-[12px] p-6 md:p-10 max-w-[520px] mx-auto" data-id="element-142" data-mp="97o69qsqjst2">
          <div className="space-y-3 min-h-[500px]" data-id="element-143" data-mp="e7sp3nh48zmg">
            <motion.div animate={step >= 1 ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.3
          }} className="flex justify-end" data-id="element-144" data-mp="j52ljn2xabjs">
              <div className="bg-arena text-carbon font-body text-[14px] rounded-[12px] rounded-tr-none px-4 py-2.5 max-w-[85%]" data-id="element-145" data-mp="2a9w2qqvtsfb2">
                {data.clientMsg}
              </div>
            </motion.div>

            <motion.div animate={step === 2 ? {
            opacity: 1
          } : {
            opacity: 0
          }} transition={{
            duration: 0.25
          }} className="flex justify-start" data-id="element-146" data-mp="2k7a73s4h5dn0">
              <div className="bg-verde/20 text-arena/70 font-body text-[12px] italic rounded-[12px] rounded-tl-none px-4 py-2" data-id="element-147" data-mp="2ty4vp3570pbm">
                {data.aiTyping}
              </div>
            </motion.div>

            <motion.div animate={step >= 3 ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.3
          }} className="flex justify-start -mt-2" data-id="element-148" data-mp="32xruriag9j1i">
              <div className="bg-verde text-arena font-body text-[14px] rounded-[12px] rounded-tl-none px-4 py-2.5 max-w-[85%]" data-id="element-149" data-mp="18lbtkvwigv3i">
                {data.aiReply}
              </div>
            </motion.div>

            {/* Client reply */}
            <motion.div animate={step >= 4 ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.3
          }} className="flex justify-end mt-1" data-id="element-150" data-mp="3p8b4xas7zuvk">
              <div className="bg-arena text-carbon font-body text-[14px] rounded-[12px] rounded-tr-none px-4 py-2.5 max-w-[85%]" data-id="element-151" data-mp="31gw11dksp5i7">
                {data.clientReply}
              </div>
            </motion.div>

            {/* AI confirm */}
            <motion.div animate={step >= 5 ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.3
          }} className="flex justify-start -mt-2" data-id="element-152" data-mp="2rjrkpudms49b">
              <div className="bg-verde text-arena font-body text-[14px] rounded-[12px] rounded-tl-none px-4 py-2.5 max-w-[85%]" data-id="element-153" data-mp="pruztu5kpi1v">
                {data.aiConfirm}
              </div>
            </motion.div>

            <motion.div animate={step >= 6 ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.3
          }} className="bg-arena/5 border border-arena/15 rounded-[12px] px-4 py-3 mt-4" data-id="element-154" data-mp="2qsru2yuv94uv">
              <span className="block font-body text-[10px] uppercase tracking-[0.1em] text-verde mb-1.5" data-id="element-155" data-mp="2cubfklqria26">
                DATOS EXTRAÍDOS ✓
              </span>
              <div className="font-body text-[13px] text-arena/80 space-y-0.5" data-id="element-156" data-mp="27wjlpm6k4dvc">
                {data.panel1.map(row => <p key={row.k} data-id="element-157" data-mp="1z255nhe7czb6">
                    {row.k}: {row.v}
                  </p>)}
              </div>
            </motion.div>

            <motion.div animate={step >= 7 ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.3
          }} data-id="element-158" data-mp="1u550r9t3a2ln">
              <span className="font-body text-[12.5px] font-medium text-arena/85 flex items-center gap-2" data-id="element-159" data-mp="1k4uq9wyfv9a6">
                LEAD CALIFICADO <span className="text-verde" data-id="element-160" data-mp="1a0nyumqcvr9y">✓</span>
                <span className="text-arena/50" data-id="element-161" data-mp="1f00p7hgfrgha">· {data.qualified}</span>
              </span>
            </motion.div>

            <motion.div animate={step >= 8 ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.3
          }} className="bg-arena/5 border border-arena/15 rounded-[12px] px-4 py-3" data-id="element-162" data-mp="1jz3t2ykojgno">
              <span className="block font-body text-[10px] uppercase tracking-[0.1em] text-salvia mb-2" data-id="element-163" data-mp="r8li7bdpsazp">
                {data.panel2Title} ✓
              </span>
              <div className="flex flex-wrap gap-2" data-id="element-164" data-mp="1183x3derp6kw">
                {data.panel2Chips.map(chip => <span key={chip} className="font-body text-[12px] text-arena/80 bg-arena/10 rounded-full px-3 py-1" data-id="element-165" data-mp="160dsh8yniyuk">
                    {chip}
                  </span>)}
              </div>
            </motion.div>

            <motion.div animate={step >= 9 ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.3
          }} className="pt-1" data-id="element-166" data-mp="5haoi3pu0lil">
              <span className="block font-body text-[10px] uppercase tracking-[0.1em] text-arena/40 mb-1" data-id="element-167" data-mp="f7derw5kjld8">
                CRM
              </span>
              <span className="font-body text-[13px] font-medium text-arena/85 flex items-center gap-2" data-id="element-168" data-mp="abodnodwhwet">
                {data.crmText} <span className="text-verde" data-id="element-169" data-mp="3dqan66dwycq9">✓</span>
              </span>
            </motion.div>

            <motion.div animate={step >= 10 ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.3
          }} data-id="element-170" data-mp="3sn1owmb280j1">
              <span className="block font-body text-[10px] uppercase tracking-[0.1em] text-arena/40 mb-1" data-id="element-171" data-mp="3nqb6vtfp2uuz">
                ACCIÓN
              </span>
              <span className="font-body text-[14px] font-medium text-arena flex items-center gap-2" data-id="element-172" data-mp="12ysj1ugwocr4">
                {data.actionText} <span className="text-verde" data-id="element-173" data-mp="1agqtc16wvrve">✓</span>
              </span>
            </motion.div>

            <motion.div animate={step >= 11 ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.3
          }} data-id="element-174" data-mp="1fhefo9k73kja">
              <span className="block font-body text-[10px] uppercase tracking-[0.1em] text-arena/40 mb-1" data-id="element-175" data-mp="15hvxnynui8tv">
                SEGUIMIENTO
              </span>
              <span className="font-body text-[12.5px] text-arena/55 flex items-center gap-2" data-id="element-176" data-mp="1t8ruxbb2lw8i">
                {data.followupText} <span className="text-verde" data-id="element-177" data-mp="1y8xhid2hgsjq">✓</span>
              </span>
            </motion.div>
          </div>

          <button onClick={replay} className="mt-6 inline-flex items-center gap-1.5 font-body text-[12px] text-arena/50 hover:text-arena/80 transition-opacity duration-150" data-id="element-178" data-mp="1oh1jf20ed2fi">
            <RotateCcw size={12} data-id="element-179" data-mp="2gy44icab86bc" /> Ver de nuevo
          </button>
        </div>
      </div>
    </section>;
}